// touch screens have no hover: a tap on a partner plate opens its photo
document.querySelectorAll('.partner-plate').forEach((plate) => {
  plate.addEventListener('click', () => plate.closest('.partner').classList.toggle('is-open'));
});
